<div id="cookie-banner" data-secure="false" class="sticky">
	<div class="cookie-banner-wrapper">
		<div class="cookie-banner-text">
			<p class="title">{{ 'common.cookies-banner.title' | translate }}</p>
			<p>{{ 'common.cookies-banner.description' | translate }}
				@if ((items | async); as item) {
					<banner-link [item]="item.cookiesSettings"></banner-link>.
					<br>
					<banner-link [item]="item.privacyPolicy"></banner-link>
					@if (showSeparator()) {
						<span> | </span>
					}
					<banner-link [item]="item.legalNotices"></banner-link>
				}
			</p>

		</div>
		<div class="cookie-banner-buttons">
			<button class="btn btn-white banner-btn arrow-icon"
					(click)="acceptCookies()">{{ 'common.cookies-banner.accept-all-btn' | translate }}
				<nb-icon id="arrow-icon" status="primary" icon="arrow-ios-forward-outline"></nb-icon>
			</button>
			<button class="btn btn-white banner-btn arrow-icon settings-btn"
					(click)="goToSettings()">{{ 'common.cookies-banner.settings-btn' | translate }}
				<nb-icon id="arrow-icon" status="primary" icon="arrow-ios-forward-outline"></nb-icon>
			</button>
		</div>
	</div>
	<button class="close-btn" (click)="close()">
		<nb-icon status="primary" icon="close-outline"></nb-icon>
	</button>
</div>
